import excuseApi from '../api/excuseApi';
const AccountModel = {
  id: null,
  username: '',
  email: '',
  password: '',
  role: 'user',
  created_at: '',
  type: '',
};

export const register = (formData) =>
  excuseApi({
    endpoint: '/register',
    method: 'POST',
    data: formData,
  });

export const login = (formData) =>
  excuseApi({
    endpoint: '/login',
    method: 'POST',
    data: formData,
  });

export const getCurrentUser = async () => {
  const token = localStorage.getItem('token');
  if (!token || token == undefined) return null;

  try {
    const res = excuseApi({
      endpoint: '/me',
      method: 'GET',
    });
    return res;
  } catch (err) {
    localStorage.removeItem('token');
    return null;
  }
};

export const changePassword = (accountId, oldPassword, newPassword) =>
  excuseApi({
    endpoint: `/accounts/${accountId}/change-password`,
    method: 'PUT',
    data: {
      old_password: oldPassword,
      new_password: newPassword
    },
  });

  export const getAllAccounts = async () => {
    try {
      const res = await excuseApi({
        endpoint: '/accounts',
        method: 'GET',
      });
      return res;
    } catch (err) {
      console.error('Error fetching accounts:', err);
      return [];
    }
  };

export default AccountModel;
